if (!customElements.get('product-buy-now')) {
  class ProductBuyNow extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        buttonHandler: '.js-add-to-cart-handler',
        errorPopup: '.error-popup',
        confirmationPopup: '.confirmation-popup',
        basketCounter: '.headerIcons__basket--counter',
        confirmationImage: '.confirmation-popup__item-details-image',
        confirmationTitle: '.confirmation-popup__item-details-name',
        errorPopupDescription: '.error-popup__description',
        cartDrawer: 'cart-drawer',

        confirmationPopupActiveClass: 'confirmation-popup--active',
        errorPopupActiveClass: 'error-popup--active',
        buttonHandlerInitClass: 'handler-init',
        cartDrawerEmptyClass: 'is-empty',
      };

      this.buttonHandler = this.querySelector(this.selectors.buttonHandler);
      this.errorPopup = document.querySelector(this.selectors.errorPopup);
      this.confirmationPopup = document.querySelector(this.selectors.confirmationPopup);
      this.confirmationPopupDelay = this.confirmationPopup.dataset.closeTime;
      this.errorPopupDelay = this.errorPopup.dataset.closeTime;
    }

    connectedCallback() {
      if (this.buttonHandler.classList.contains(this.selectors.buttonHandlerInitClass)) return;

      this.buttonHandler.addEventListener('click', this.addToCart.bind(this));
      this.buttonHandler.classList.add(this.selectors.buttonHandlerInitClass);
    }

    disconnectedCallback() {
      this.buttonHandler.removeEventListener('click', this.addToCart.bind(this));
    }

    async addToCart() {
      try {
        const data = {
          items: [
            {
              id: this.buttonHandler.dataset.id,
              quantity: 1
            }
          ],
          sections: ["cart-drawer", "header"]
        };

        this.confirmationPopup.classList.remove(this.selectors.confirmationPopupActiveClass);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message);
        }

        const currentProduct = result.items[0];
        const confirmationImage = document.querySelector(this.selectors.confirmationImage);
        const confirmationTitle = document.querySelector(this.selectors.confirmationTitle);
        const basketCounter = document.querySelector(this.selectors.basketCounter);
        const cartDrawer = document.querySelector(this.selectors.cartDrawer);

        if (cartDrawer && cartDrawer.renderContents && result.sections) {
          cartDrawer.renderContents(result, false);
          cartDrawer.classList.remove(this.selectors.cartDrawerEmptyClass);
        }

        const clearAllTimeouts = () => {
          if (this.showTimeoutId) clearTimeout(this.showTimeoutId);
          if (this.hideTimeoutId) clearTimeout(this.hideTimeoutId);
        };

        clearAllTimeouts();

        confirmationTitle.innerText =  currentProduct.title;

        const tempImage = new Image();

        tempImage.src = currentProduct.image + '&width=100';
        tempImage.onload = () => {
          confirmationImage.src = currentProduct.image + '&width=100';

          this.showTimeoutId = setTimeout(() => {
            this.confirmationPopup.classList.add(this.selectors.confirmationPopupActiveClass);
          }, 100);

          this.hideTimeoutId = setTimeout(() => {
            this.confirmationPopup.classList.remove(this.selectors.confirmationPopupActiveClass);
          }, +this.confirmationPopupDelay);
        };

        this.errorPopup.classList.remove(this.selectors.errorPopupActiveClass);
      } catch (error) {
        const errorPopupDescription = document.querySelector(this.selectors.errorPopupDescription);

        errorPopupDescription.innerHTML = error;
        this.errorPopup.classList.add(this.selectors.errorPopupActiveClass);

        setTimeout(() => {
          this.errorPopup.classList.remove(this.selectors.errorPopupActiveClass);
        }, +this.errorPopupDelay);
      }
    }
  }

  customElements.define('product-buy-now', ProductBuyNow);
}
